import { Col } from "antd";
import React from "react";
interface INewEntryFromLeftColWrapperProps {
  children: React.ReactNode;
}
const LeftCol: React.FC<INewEntryFromLeftColWrapperProps> = ({ children }) => {
  return (
    <Col xl={10} xxl={10} lg={10} md={24} sm={24} xs={24}>
      {children}
    </Col>
  );
};
export default LeftCol;
